var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 180",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F2F2F2;}\r\n\t.st1{fill:#F5F0D9;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFD55C;}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#45525B;}\r\n\t.st4{fill:#45525B;}\r\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#CFDBE5;}\r\n\t.st6{fill:#657077;}\r\n\t.st7{fill:#CFDBE5;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_482_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90,27.1c-35.7,0-64.6,28.9-64.6,64.6c0,35.7,28.9,64.6,64.6,64.6c35.7,0,64.6-28.9,64.6-64.6 C154.6,56,125.7,27.1,90,27.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.1,124.7H67.5c-1.5,0-2.8,1.3-2.8,2.8v0.4c0,1.5,1.3,2.8,2.8,2.8h47.6c1.5,0,2.8-1.3,2.8-2.8v-0.4 C117.9,126,116.7,124.7,115.1,124.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113,136.3H60c-1.5,0-2.8,1.3-2.8,2.8v0.4c0,1.5,1.3,2.8,2.8,2.8h53c1.5,0,2.8-1.3,2.8-2.8v-0.4 C115.8,137.6,114.5,136.3,113,136.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.9,130.5h-4.8c-1.5,0-2.8,1.3-2.8,2.8v0.4c0,1.5,1.3,2.8,2.8,2.8h4.8c1.5,0,2.8-1.3,2.8-2.8v-0.4 C128.7,131.8,127.4,130.5,125.9,130.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.4,146.2H82.2c-1.4,0-2.6,1.2-2.6,2.6v0.1c0,1.4,1.2,2.6,2.6,2.6h14.2c1.4,0,2.6-1.2,2.6-2.6v-0.1 C99,147.3,97.9,146.2,96.4,146.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.9,124.7h-4.8c-1.5,0-2.8,1.3-2.8,2.8v0.4c0,1.5,1.3,2.8,2.8,2.8h4.8c1.5,0,2.8-1.3,2.8-2.8v-0.4 C61.7,126,60.4,124.7,58.9,124.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111.7,130.5H68.2c1.5,0,2.6,1.2,2.6,2.6v0.7c0,1.5-1.2,2.6-2.6,2.6h43.5c-1.5,0-2.6-1.2-2.6-2.6v-0.7 C109,131.7,110.2,130.5,111.7,130.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96,142.3H82.4c0.9,0,1.7,0.8,1.7,1.7v0.4c0,0.9-0.8,1.7-1.7,1.7H96c-0.9,0-1.7-0.8-1.7-1.7V144 C94.3,143.1,95,142.3,96,142.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.9,114.4H92.5c-1.5,0-2.8,1.3-2.8,2.8v0.4c0,1.5,1.3,2.8,2.8,2.8h16.4c1.5,0,2.8-1.3,2.8-2.8v-0.4 C111.7,115.6,110.5,114.4,108.9,114.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.6,120.3H93.2c1.1,0,1.9,0.9,1.9,1.9v0.5c0,1.1-0.9,1.9-1.9,1.9h15.4c-1.1,0-1.9-0.9-1.9-1.9v-0.5 C106.7,121.2,107.5,120.3,108.6,120.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_416_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_878_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.7,
    y: 43,
    className: "st2",
    width: 11.6,
    height: 97.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_876_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 71.2,
    y: 43,
    className: "st2",
    width: 4.1,
    height: 97.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_875_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.8,
    y: 43.6,
    className: "st3",
    width: 2.5,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_874_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.8,
    y: 45.8,
    className: "st3",
    width: 2.5,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_873_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.3,
    y: 47.9,
    className: "st3",
    width: 4,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_872_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.8,
    y: 50.1,
    className: "st3",
    width: 2.5,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_871_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.8,
    y: 52.2,
    className: "st3",
    width: 2.5,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_869_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.3,
    y: 54.4,
    className: "st3",
    width: 4,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_868_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.8,
    y: 56.6,
    className: "st3",
    width: 2.5,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_867_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.8,
    y: 58.7,
    className: "st3",
    width: 2.5,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_866_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.3,
    y: 60.9,
    className: "st3",
    width: 4,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_865_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.8,
    y: 63.1,
    className: "st3",
    width: 2.5,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_864_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.8,
    y: 65.2,
    className: "st3",
    width: 2.5,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_862_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.3,
    y: 67.4,
    className: "st3",
    width: 4,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_859_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.8,
    y: 69.5,
    className: "st3",
    width: 2.5,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_858_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.7,
    y: 70.8,
    transform: "matrix(1.550879e-03 -1 1 1.550879e-03 1.8899 146.0144)",
    className: "st3",
    width: 0.7,
    height: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_857_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.3,
    y: 73.8,
    className: "st3",
    width: 4,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_853_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.3,
    y: 73.8,
    className: "st3",
    width: 4,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_852_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "72.8,76.8 75.3,76.8 75.3,76 72.8,76  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_851_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.8,
    y: 78.2,
    className: "st3",
    width: 2.5,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_850_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.3,
    y: 80.3,
    className: "st3",
    width: 4,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_849_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.3,
    y: 80.3,
    className: "st3",
    width: 4,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_481_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.8,
    y: 82.5,
    className: "st3",
    width: 2.5,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_480_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.8,
    y: 84.7,
    className: "st3",
    width: 2.5,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_845_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.9,
    y: 85.1,
    transform: "matrix(1.211701e-03 -1 1 1.211701e-03 -13.9705 160.349)",
    className: "st3",
    width: 0.7,
    height: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_843_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.9,
    y: 85.1,
    transform: "matrix(1.211701e-03 -1 1 1.211701e-03 -13.9705 160.349)",
    className: "st3",
    width: 0.7,
    height: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_842_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.8,
    y: 89,
    className: "st3",
    width: 2.5,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_841_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "72.8,91.9 75.3,91.9 75.3,91.1 72.8,91.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_840_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.3,
    y: 93.3,
    className: "st3",
    width: 4,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_479_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.3,
    y: 93.3,
    className: "st3",
    width: 4,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_478_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.8,
    y: 95.5,
    className: "st3",
    width: 2.5,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_477_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.7,
    y: 96.7,
    transform: "matrix(1.153269e-03 -1 1 1.153269e-03 -24.0286 171.9138)",
    className: "st3",
    width: 0.7,
    height: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_828_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.3,
    y: 99.8,
    className: "st3",
    width: 4,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_827_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.3,
    y: 99.8,
    className: "st3",
    width: 4,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_826_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.8,
    y: 101.9,
    className: "st3",
    width: 2.5,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_476_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.8,
    y: 104.1,
    className: "st3",
    width: 2.5,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_475_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.2,
    y: 106.2,
    className: "st3",
    width: 4,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_823_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.2,
    y: 106.2,
    className: "st3",
    width: 4,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_821_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.8,
    y: 108.4,
    className: "st3",
    width: 2.5,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_820_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.8,
    y: 110.6,
    className: "st3",
    width: 2.5,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_817_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.2,
    y: 112.7,
    className: "st3",
    width: 4,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_816_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.2,
    y: 112.7,
    className: "st3",
    width: 4,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_815_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.8,
    y: 114.9,
    className: "st3",
    width: 2.5,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_814_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.8,
    y: 117.1,
    className: "st3",
    width: 2.5,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_813_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.2,
    y: 119.2,
    className: "st3",
    width: 4,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_474_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.2,
    y: 119.2,
    className: "st3",
    width: 4,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_471_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.8,
    y: 121.4,
    className: "st3",
    width: 2.5,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_470_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.6,
    y: 122.7,
    transform: "matrix(1.193459e-03 -1 1 1.193459e-03 -49.9793 197.7788)",
    className: "st3",
    width: 0.7,
    height: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_747_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.2,
    y: 125.7,
    className: "st3",
    width: 4,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_461_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.2,
    y: 125.7,
    className: "st3",
    width: 4,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_454_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.6,
    y: 127,
    transform: "matrix(1.552113e-03 -1 1 1.552113e-03 -54.3439 202.0585)",
    className: "st3",
    width: 0.7,
    height: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_436_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.8,
    y: 130,
    className: "st3",
    width: 2.5,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_433_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.2,
    y: 132.2,
    className: "st3",
    width: 4,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_431_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.2,
    y: 132.2,
    className: "st3",
    width: 4,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_424_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.8,
    y: 134.4,
    className: "st3",
    width: 2.5,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_423_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.7,
    y: 136.5,
    className: "st3",
    width: 2.5,
    height: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_417_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.2,
    y: 138.6,
    className: "st3",
    width: 4,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_432_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M136.7,90.2c0-1.2-0.1-2.4-0.3-3.7l-3.9-0.8c-0.1-0.7-0.2-1.4-0.4-2.2l3.5-2c-0.3-1.2-0.6-2.4-0.9-3.5l-4,0 c-0.2-0.7-0.5-1.4-0.7-2.1l3.1-2.6c-0.5-1.1-1-2.2-1.6-3.3l-3.9,0.7c-0.4-0.6-0.7-1.3-1.1-1.9l2.5-3.1c-0.7-1-1.4-2-2.1-3 l-3.7,1.4c-0.5-0.6-0.9-1.1-1.4-1.7l1.9-3.5c-0.8-0.9-1.7-1.7-2.7-2.5l-3.4,2.1c-0.6-0.5-1.1-0.9-1.7-1.4l1.2-3.8 c-0.5-0.4-1-0.7-1.5-1c-0.5-0.3-1-0.6-1.6-1l-3,2.7c-0.6-0.4-1.3-0.7-1.9-1l0.5-4c-1.1-0.5-2.2-1-3.4-1.4l-2.4,3.2 c-0.7-0.2-1.4-0.4-2.1-0.6l-0.2-4c-1.2-0.3-2.4-0.5-3.6-0.8l-1.8,3.6c-0.7-0.1-1.4-0.2-2.2-0.2l-1-3.9C91.5,45,90.3,45,89.1,45 L88,48.9c-0.7,0-1.5,0.1-2.2,0.2l-1.7-3.6c-1.2,0.2-2.4,0.4-3.6,0.6l-0.4,4c-0.7,0.2-1.4,0.4-2.1,0.6l-2.3-3.3 c-1.2,0.4-2.3,0.8-3.4,1.3l0.3,4c-0.7,0.3-1.3,0.6-2,0.9l-2.9-2.8c-1.1,0.6-2.1,1.2-3.1,1.9l1.1,3.8c-0.6,0.4-1.2,0.8-1.8,1.3 l-3.3-2.2c-0.9,0.8-1.9,1.6-2.8,2.4l1.8,3.6c-0.5,0.5-1,1-1.5,1.6l-3.7-1.6c-0.8,0.9-1.5,1.9-2.3,2.9l2.4,3.2 c-0.2,0.3-0.4,0.6-0.6,0.9c-0.2,0.3-0.4,0.6-0.6,0.9l-3.9-0.9c-0.6,1.1-1.2,2.2-1.7,3.3l2.9,2.7c-0.3,0.7-0.6,1.3-0.8,2l-4-0.1 c-0.4,1.2-0.8,2.3-1.1,3.5l3.4,2.1c-0.2,0.7-0.3,1.4-0.4,2.1l-4,0.6c-0.2,1.2-0.3,2.4-0.4,3.6l3.7,1.5c0,0.7,0,1.5,0,2.2l-3.8,1.3 c0,1.2,0.1,2.4,0.3,3.7l3.9,0.8c0.1,0.7,0.2,1.4,0.4,2.2l-3.5,2c0.3,1.2,0.6,2.4,0.9,3.5l4,0c0.2,0.7,0.5,1.4,0.7,2.1L47,110 c0.5,1.1,1,2.2,1.6,3.3l3.9-0.7c0.4,0.6,0.7,1.3,1.1,1.9l-2.5,3.1c0.7,1,1.4,2,2.2,3l3.7-1.4c0.5,0.6,0.9,1.1,1.4,1.7l-1.9,3.5 c0.8,0.9,1.7,1.7,2.7,2.5l3.4-2.1c0.6,0.5,1.1,0.9,1.7,1.4l-1.2,3.8c0.5,0.4,1,0.7,1.5,1c0.5,0.3,1,0.6,1.6,1l3-2.7 c0.6,0.4,1.3,0.7,1.9,1l-0.5,4c1.1,0.5,2.2,1,3.4,1.4l2.4-3.2c0.7,0.2,1.4,0.4,2.1,0.6l0.2,4c1.2,0.3,2.4,0.5,3.6,0.8l1.8-3.6 c0.7,0.1,1.4,0.2,2.2,0.2l1,3.9c1.2,0.1,2.4,0.1,3.7,0.1l1.1-3.9c0.7,0,1.5-0.1,2.2-0.2l1.7,3.6c1.2-0.2,2.4-0.4,3.6-0.6l0.4-4 c0.7-0.2,1.4-0.4,2.1-0.6l2.3,3.3c1.2-0.4,2.3-0.8,3.4-1.3l-0.3-4c0.7-0.3,1.3-0.6,2-0.9l2.9,2.8c1.1-0.6,2.1-1.2,3.1-1.9 l-1.1-3.8c0.6-0.4,1.2-0.8,1.8-1.3l3.3,2.2c0.9-0.8,1.9-1.6,2.8-2.4l-1.8-3.6c0.5-0.5,1-1,1.5-1.6l3.7,1.6 c0.8-0.9,1.5-1.9,2.3-2.9l-2.4-3.2c0.2-0.3,0.4-0.6,0.6-0.9c0.2-0.3,0.4-0.6,0.6-0.9l3.9,0.9c0.6-1.1,1.2-2.2,1.7-3.3l-2.9-2.7 c0.3-0.7,0.6-1.3,0.8-2l4,0.1c0.4-1.2,0.8-2.3,1.1-3.5l-3.4-2.1c0.2-0.7,0.3-1.4,0.4-2.1l4-0.6c0.2-1.2,0.3-2.4,0.4-3.6l-3.7-1.5 c0-0.7,0-1.5,0-2.2L136.7,90.2z M111.5,62c7,5.1,11.7,12.3,13.9,20.1l-23.5,5c-0.7-1.9-1.9-3.6-3.4-5L111.5,62z M108.2,59.9 l-13,20.2c-1.9-0.9-3.9-1.2-5.9-1.1l-5-23.5C92.3,54.2,100.7,55.6,108.2,59.9z M80.4,56.3l5,23.5c-1.7,0.7-3.3,1.7-4.6,3 c-0.1,0.1-0.2,0.2-0.3,0.4l-20.2-13C65.4,63.2,72.6,58.5,80.4,56.3z M58.2,73.5l20.2,13c-0.8,1.9-1.2,3.9-1.1,5.9l-23.5,5 C52.5,89.5,53.9,81,58.2,73.5z M68.5,121.4c-7-5.1-11.7-12.2-13.9-20.1l23.5-5c0.6,1.7,1.7,3.3,3.1,4.6c0.1,0.1,0.3,0.2,0.4,0.3 L68.5,121.4z M71.8,123.5l13-20.2c1.1,0.5,2.2,0.8,3.3,1c0.9,0.1,1.7,0.2,2.6,0.1l5,23.5C87.7,129.2,79.3,127.8,71.8,123.5z  M99.6,127.1l-5-23.5c1.9-0.7,3.6-1.9,5-3.4l20.2,13C114.6,120.3,107.4,125,99.6,127.1z M121.8,110l-20.2-13 c0.9-1.9,1.2-4,1.1-5.9l23.5-5C127.5,94,126.1,102.4,121.8,110z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M99.3,29.6c0-2.3-0.8-4.3-2.1-5.9h-0.9c0.5,1,0.7,2,0.7,3.1c0.1,1.7-0.8,3.7-2,4.9c-1.3,1.3-3.1,2-4.9,2 c-1.9,0-3.6-0.8-4.9-2c-1.4-1.3-2-3.1-2-4.9c0-1,0.3-2.1,0.7-3.1h-0.7c-1.3,1.6-2.1,3.6-2.1,5.8c0,3.7,2.2,6.9,5.3,8.4l-0.1,42.4 c-3.2,1.4-5.4,4.6-5.4,8.3c0,2.4,0.9,4.6,2.4,6.2h0.8c-0.6-1.1-0.9-2.3-1-3.6c-0.1-1.7,0.8-3.7,2-4.9c1.3-1.3,3.1-2,4.9-2 c1.9,0,3.6,0.8,4.9,2c1.4,1.3,2,3.1,2,4.9c0.1,1.2-0.4,2.5-1,3.6h0.8c1.5-1.6,2.4-3.8,2.4-6.1c0-3.7-2.2-6.9-5.3-8.4l0.1-42.4 C97,36.5,99.3,33.3,99.3,29.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M83.4,86.4c-1.2,1.2-2.1,3.2-2,4.9c0,0.3,0,0.6,0.1,0.8c0.4,1,1,1.9,1.7,2.7h0.8c-0.6-1.1-0.9-2.3-1-3.6 c-0.1-1.7,0.8-3.7,2-4.9c1.1-1.1,2.6-1.8,4.1-2c-0.3,0-0.5-0.1-0.8-0.1C86.5,84.3,84.6,85.1,83.4,86.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M83,26.8c0-1,0.3-2.1,0.7-3.1h-0.7c-0.7,0.9-1.3,1.9-1.7,2.9c0,0.1,0,0.1,0,0.2c0.1,1.8,0.7,3.7,2,4.9 c1.4,1.3,3,2,4.9,2c0.3,0,0.5,0,0.8-0.1c-1.6-0.2-2.9-0.9-4.1-2C83.7,30.4,83.1,28.6,83,26.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M99.3,29.6c0-2.3-0.8-4.3-2.1-5.9h-0.9c0.3,0.7,0.5,1.4,0.6,2.2c0.5,1.2,0.8,2.4,0.8,3.8 c0,3.7-2.3,6.9-5.4,8.3l-0.1,42.4c3.2,1.5,5.4,4.7,5.3,8.4c0,1.1-0.2,2.2-0.6,3.2c-0.1,1-0.4,2.1-1,3h0.8 c1.5-1.6,2.4-3.8,2.4-6.1c0-3.7-2.2-6.9-5.3-8.4l0.1-42.4C97,36.5,99.3,33.3,99.3,29.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M93.1,86.7c-2.8-1.7-6.4-0.8-8.1,2c-1.7,2.8-0.8,6.4,2,8.1c2.8,1.7,6.4,0.8,8.1-2 C96.8,92,95.9,88.4,93.1,86.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M87.8,88.5c-0.4-0.3-1-0.3-1.3,0.1c-0.3,0.4-0.3,1,0.1,1.3l5.7,5c0,0,0.1,0.1,0.1,0.1 c0.4,0.2,0.9,0.2,1.2-0.2c0.3-0.4,0.3-1-0.1-1.3L87.8,88.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M91.8,88.3l-5,5.7c-0.3,0.4-0.3,1,0.1,1.3c0,0,0.1,0.1,0.1,0.1c0.4,0.2,0.9,0.2,1.2-0.2l5-5.7 c0.3-0.4,0.3-1-0.1-1.3C92.7,87.8,92.1,87.9,91.8,88.3z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.59d0b94ad304a057d12a786fb10aae97.svg";
export { ForwardRef as ReactComponent };